import Vue from 'vue'
import { API_URL } from '@/config'
import router from '@/router'
import { prepareValues } from '@/lib/values'

export const presentation_persons = {

  namespaced: true,

  state: {
    roles: [],
    assigned: [],
    filters: [
      { column: 'last_name', label: 'last_name', options: { type: false }, value: '', status: true },
    ],
    options: {
      last_name: { label: 'last_name', element: 'text' },
    },
    persons: [],
    role_id: null,
    values: {},
    entities: [],
  },

  getters: {
    roles: state => state.roles,
    assigned: state => state.assigned,
    filters: state => state.filters,
    options: state => state.options,
    persons: state => state.persons,
    role_id: state => state.role_id,
    values: state => state.values,
    entities: state => state.entities,
  },

  mutations: {
    setRoles(state, roles) { 
      state.roles = roles;
      state.role_id = roles[0].value;
    },
    setAssigned(state, assigned) { state.assigned = assigned },
    setOptions(state, options) { state.options = options },
    setPersons(state, persons) { 
      for (let i in persons) persons[i].role_id = state.roles[0].value;
      state.persons = persons;
    },
    setRole(state) { 
      state.role_id = state.roles[0].value; 
    },
    setValues(state) { 
      for (let i in state.entities) {
        if (state.entities[i].column === undefined) continue;
        state.values[state.entities[i].column] = '';
      }
    },
    setEntities(state, entities) { state.entities = entities },
    clearFilters(state) {
      state.filters = [
        { column: 'last_name', label: 'last_name', options: { type: false }, value: '', status: true },
      ];
      state.options = {
        last_name: { label: 'last_name', element: 'text' },
      };
    },
  },

  actions: {

    getRoles: () =>Vue.axios.get(API_URL + '/options', { params: {
      group: ['presentation_person_role'],
    }}),

    getAssigned: () => Vue.axios.get(API_URL + '/presentations/' + router.currentRoute.params.id + '/persons'),

    getOptions: () => Vue.axios.get(API_URL + '/entities', { params: {
      models: ['App\\Models\\Person'],
      filter_display: true,
    }}),

    getEntities: () => Vue.axios.get(API_URL + '/entities', { params: {
      models: ['App\\Models\\Person'],
      form_display: true,
      form_required: true,
    }}),

    async getSpeakers({ rootState, commit, dispatch }) {
      commit('clearResponse', {}, { root: true });
      commit('setAssigned', []);
      const [roles, assigned, options, entities] = await Promise.all([
        dispatch('getRoles'),
        dispatch('getAssigned'),
        dispatch('getOptions'),
        dispatch('getEntities'),
      ]);
      commit('setProgress', false, { root: true });
      commit('setRoles', roles.data.presentation_person_role.map(role => { return { value: role.value, label: role.name } }));
      commit('setAssigned', assigned.data);
      options.data['App\\Models\\Person'].country_id.options = options.data['App\\Models\\Person'].country_id.options.sort((a, b) => rootState._[a.name].localeCompare(rootState._[b.name]));
      commit('setOptions', options.data['App\\Models\\Person']);
      let countries = entities.data['App\\Models\\Person'].findIndex(entity => entity.column === 'country_id');
      entities.data['App\\Models\\Person'][countries].options = entities.data['App\\Models\\Person'][countries].options.sort((a, b) => rootState._[a.name].localeCompare(rootState._[b.name]));
      commit('setEntities', entities.data['App\\Models\\Person']);
    },

    async addSpeaker({ state, rootState, commit }, person) {
      if (!rootState.progress) {
        const assigned = await Vue.axios.post(API_URL + '/presentations/' + router.currentRoute.params.id + '/persons', {
          presentation_id: router.currentRoute.params.id,
          id: person.id,
          role_id: person.role_id,
        });
        let id = person.id;
        commit('setPersons', state.persons.filter(person => id != person.id));
        commit('setProgress', false, { root: true });
        commit('setRole');
        commit('setValues', {});
        commit('setAssigned', assigned.data);
      }
    },

    async updateSpeakers({ state, rootState, commit }) {
      if (!rootState.progress) {
        const assigned = await Vue.axios.put(API_URL + '/presentations/' + router.currentRoute.params.id + '/persons', state.assigned);
        commit('setProgress', false, { root: true });
        commit('setAssigned', assigned.data);
      }
    },

    async removeSpeaker({ rootState, commit }, id) {
      if (!rootState.progress) {
        const assigned = await Vue.axios.delete(API_URL + '/presentations/' + router.currentRoute.params.id + '/persons/' + id);
        commit('setProgress', false, { root: true });
        commit('setAssigned', assigned.data);
      }
    },

    async getPersons({ state, rootState, getters, commit }) {
      if (!rootState.progress) {
        let assigned = state.assigned.reduce((carry, presentation_person) => { 
          carry.push(presentation_person.person_id);
          return carry;
        }, []);
        const persons = await Vue.axios.get(API_URL + '/persons', {
          params: {
            filters: getters.filters.concat([
              { column: 'id', not: true, value: assigned.join(','), status: true },
            ]),
            limit: 20,
          }
        });
        commit('setProgress', false, { root: true });
        commit('setPersons', persons.data.items);
      }
    },

    async validatePerson({ state, rootState, commit, dispatch }) {
      if (!rootState.progress) {
        try {
          await Vue.axios.post(API_URL + '/validate?model=App\\Models\\Person', state.values, {
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            }
          });
        } catch (error) {
          commit('setProgress', false, { root: true });
          commit('setResponse', { status: true, type: 'error', message: 'form_error', errors: error.response.data.errors }, { root: true });
          return;
        }
        commit('clearResponse', {}, { root: true });
        dispatch('createPerson', prepareValues(state.values, 'content_'));
      }
    },

    async createPerson({ state, commit, dispatch }, values) {
      const person = await Vue.axios.post(API_URL + '/persons', values);
      commit('setProgress', false, { root: true });
      dispatch('addSpeaker', {
        id: person.data.id,
        role_id: state.role_id,
      });
    },

  }
}
